import type { FieldValues } from 'react-hook-form'
import { Controller } from 'react-hook-form'

import { MenuItem, TextField } from '@mui/material'

import type { ControlledFieldBaseProps } from './types'

/**
 * MUI `select` `TextField` bound to a react-hook-form `Controller`, rendering
 * the provided options as `MenuItem`s.
 */
export function ControlledSelectField<T extends FieldValues>({
  name,
  label,
  control,
  options,
}: ControlledFieldBaseProps<T> & { options: { value: string; label: string }[] }) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <TextField
          {...field}
          value={(field.value as string | undefined) ?? ''}
          id={name}
          label={label}
          select
          fullWidth
          error={!!fieldState.error}
          helperText={fieldState.error?.message}
          sx={{
            '& .MuiSelect-nativeInput': {
              display: 'none',
            },
          }}
        >
          {options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      )}
    />
  )
}
